<template>
    <el-dialog class="eldialogBox acBox" title="微信授权" :visible="true" append-to-body width="480px" :before-close="cancelEvent" :close-on-click-modal="false" >
        <div class="activityDialogBox">
            <div class="imgBox">
                <div class="QR-code" id="qrcode"></div>
            </div>
            <p class="tip">请使用到账微信扫描二维码授权</p>
            <el-button type="primary" @click="binding">已绑定微信</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { htmlfix } from '@/api';
import QRCode from 'qrcodejs2'
export default {
    props: ['id'],
    mounted() {
        this.$nextTick (function () {
            document.querySelector('.QR-code').innerHTML= ``
            new QRCode('qrcode', {
                width: 176,
                height: 176,        // 高度
                text:  `${htmlfix}/html/static/index.html?sponsorId=${this.id}`,   // 二维码内容
            })
        })
    },
    methods: {
        cancelEvent() {
            this.$emit('cancelEvent')
        },
        binding() {
            this.$emit('binding')
        }
    }
}
</script>

<style lang="scss">
.acBox {
    .activityDialogBox {
        text-align: center;
        .imgBox{
            width: 160px;
            height: 160px;
            margin: 0 auto;
            border: 1px solid #D8D8D8;
            border-radius: 8px;
            overflow: hidden;
            padding: 7px;
            img{
                width: 100%;
                height: 100%;
                display: block
            }
        }
        .tip {
            margin: 24px 0;
            font-size: 16px;
            font-weight: bold;
            color:rgba(0,0,0,0.85);
            line-height: 22px;
        }
    }
}
</style>